//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/MechanicalRouting.js";
import "../no/Builder.js";
import "../Routing/Routing.RouteObjectCollector.js";
import "../no/Routing.js";
let d=[[[0,"GeneratedSpoolSorting",1,0],[0,"IncludeEquipmentComponents",1,0],[1,"Members",0,"Routing.RouteObjectCollector",0]],[[["run"],"AddComponentsForRun",{},1,0],[["runBranch"],"AddComponentsForRunBranch",{},1,0],[["run"],"AddComponentsForSimplifiedViewRun",{},1,0]],[]];
SPLM.MechanicalRouting.GenerateSpoolsBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.MechanicalRouting.GenerateSpoolsBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.MechanicalRouting.GenerateSpoolsBuilder.SpoolSorting = Object.freeze({
    "ByInputComponentOrder" : "ByInputComponentOrder", "ByInputComponentOrderAndConnectivity" : "ByInputComponentOrderAndConnectivity"});

export default SPLM;